import { HelpCircle } from "lucide-react";
import { Tooltip } from "@/components/ui/tooltip";

export default function HelpFAB() {
  return (
    <Tooltip content="Help" side="left">
      <button
        type="button"
        aria-label="Help"
        className="fixed bottom-10 right-8 z-50 grid size-10 place-items-center rounded-full border border-line bg-surface text-muted shadow-sm transition-colors hover:bg-bg hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      >
        <HelpCircle aria-hidden className="size-5" />
      </button>
    </Tooltip>
  );
}
